import { render, staticRenderFns } from "./FuelConsumptionCard.vue?vue&type=template&id=5f96653a&scoped=true"
import script from "./FuelConsumptionCard.vue?vue&type=script&lang=js"
export * from "./FuelConsumptionCard.vue?vue&type=script&lang=js"
import style0 from "./FuelConsumptionCard.vue?vue&type=style&index=0&id=5f96653a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f96653a",
  null
  
)

export default component.exports